module.exports = __webpack_public_path__ + "static/media/partner3.acc38444.png";